module.exports = __webpack_public_path__ + "static/media/nulogy-paul-satkunasingam.7abc28c3.jpg";